export default __webpack_public_path__ + "static/head_bob-8b02478d0dbe2afe9050869f82b4bcee.jpg";